import React, { useContext, useEffect, useState } from 'react';
import { Input, InputProps, Select, SelectProps } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import IntlContext from '@/components/Intl/IntlContext';
import { ContractType } from '@/config';
import { renderIntlLabel } from '@/utils';
import { parseAreaMobileStr, stringifyAreaMobile } from './helper';
import styles from './index.module.scss';

const { Option } = Select;

// type TBaseMobile = {
//   areaCode: string;
//   areaName: string;
//   mobile: string;
// };
interface BaseMobileInputProps {
  isKeyPerson: boolean;
  selectProps: SelectProps;
  inputProps: Omit<InputProps, 'value' | 'onChange'>;
  value: string;
  onChange: (val: string) => void;
}

const BaseMobileInput: React.FC<Partial<BaseMobileInputProps>> = ({
  isKeyPerson = true,
  selectProps,
  inputProps,
  value,
  onChange,
}) => {
  const { TenantSysConfig, TenantBaseConfig, regionList } = useContext(IntlContext);

  const [searchInput, setSearchInput] = useState('');
  const [filterOptions, setFilterOptions] = useState([]);
  // 区号
  const [codeItem, setCodeItem] = useState<{ label?: React.ReactNode; value?: string }>({});
  const [mobile, setMobile] = useState<string>('');

  const handleInputChange = (e) => {
    setSearchInput(e.target.value);

    const list = regionList.filter(
      (item) =>
        (item.label as string)?.includes(e.target.value) ||
        (item.value as string)?.includes(e.target.value),
    );

    // 输入空
    if (!e.target.value) {
      setFilterOptions(regionList);
    } else {
      setFilterOptions(list);
    }
  };

  const handleAreaChange = (val) => {
    setCodeItem({ label: val?.label, value: val?.value });

    if (onChange) {
      const str = stringifyAreaMobile(val?.value?.trim(), mobile?.trim());
      onChange(str);
    }
  };

  const handleMobileChange = (e) => {
    setMobile(e.target.value);

    if (onChange) {
      const str = stringifyAreaMobile(codeItem?.value?.trim(), e.target.value?.trim());
      onChange(str);
    }
  };

  const renderTitle = (item) => {
    if (!item) {
      return null;
    }
    return (
      <>
        <div className={styles.title}>
          <div className={styles.left}>{item.label}</div>
          <div>{`(${item.value})`}</div>
        </div>
      </>
    );
  };

  useEffect(() => {
    const defaultCode = TenantBaseConfig.MobileAreaCode;
    const defaultItem = regionList.find((item) => item.value === defaultCode);
    setSearchInput('');
    setFilterOptions(regionList);
    if (defaultItem) {
      setCodeItem({ label: renderTitle(defaultItem), value: defaultCode });
    }
  }, [regionList, TenantBaseConfig]);

  useEffect(() => {
    const { areaCode, mobileStr } = parseAreaMobileStr(value);
    // 区号
    if (areaCode) {
      const optItem = regionList.find((item) => item.value === areaCode);
      setCodeItem({ label: renderTitle(optItem), value: areaCode });
    } else {
      const defaultCode = TenantBaseConfig.MobileAreaCode;
      const defaultItem = regionList.find((item) => item.value === defaultCode);
      if (defaultItem) {
        setCodeItem({ label: renderTitle(defaultItem), value: defaultCode });
      }
    }
    // 手机号
    setMobile(mobileStr);
  }, [value]);

  return (
    <>
      <Input.Group compact>
        <Select
          // allowClear
          // getPopupContainer={(triggerNode) => triggerNode.parentElement}
          optionLabelProp="title"
          labelInValue
          value={codeItem}
          dropdownMatchSelectWidth={380}
          dropdownRender={(ReactNode) => {
            return (
              <>
                <div className={styles.search}>
                  <Input
                    placeholder={renderIntlLabel('app_area_code_placeholder')}
                    prefix={<SearchOutlined style={{ color: '#DCDEE0' }} />}
                    value={searchInput}
                    onChange={handleInputChange}
                  />
                </div>
                {ReactNode}
              </>
            );
          }}
          onDropdownVisibleChange={() => {
            setSearchInput('');
            setFilterOptions(regionList);
          }}
          onChange={handleAreaChange}
          dropdownStyle={{ fontFamily: 'PingFang SC-Regular', fontSize: '14px', color: '#1d2129' }}
          style={{ width: 160 }}
          {...selectProps}
        >
          {filterOptions?.map((item) => (
            <Option key={item.value} value={item.value} title={item.label}>
              <div className={styles.optionsItem}>
                <div>{item.label}</div>
                <div>{item.value}</div>
              </div>
            </Option>
          ))}
        </Select>
        <Input
          maxLength={20}
          placeholder={
            isKeyPerson && TenantSysConfig?.contractType === ContractType.MOBILE
              ? renderIntlLabel('app_required')
              : renderIntlLabel('app_optional')
          }
          value={mobile}
          onChange={handleMobileChange}
          style={{ width: 220 }}
          {...inputProps}
        />
      </Input.Group>
    </>
  );
};

export default BaseMobileInput;
